// extracted by mini-css-extract-plugin
export default {"empty":"ClientList_empty__9TNf7","filterActive":"ClientList_filterActive__4k-BA","customerList":"ClientList_customerList__eRFwg"};